export const iconFontAwesomeHalloweenToiletPaper = (
	<i className="fa-solid fa-toilet-paper"></i>
);
